import { ChartFormatEnum } from "@/__generated__/graphql";
import { ThreadBox } from "@/components/organisms/ThreadInput/ThreadInputBox";
import { ThreadMessageList } from "@/components/organisms/Thread/ThreadMessageList";
import { identifierAndTypenameToId } from "@/objects/@utils";
import { cn } from "@/components/ui/utils";
import { typographyStyles } from "@/components/ui/typography";

const MockComponent = ({
  children,
  ...props
}: {
  children: React.ReactNode;
}) => {
  props;
  return <div>{children}</div>;
};

const MockInputComponent = ({
  ...props
}: {
  children: React.ReactNode;
  props: any;
}) => {
  props;
  const value = `One more thing — Can you tell me about this shopify transaction?`;

  return (
    <>
      <textarea
        value={value}
        disabled
        style={{
          padding: "8px",
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
          resize: "none",
          backgroundColor: "transparent",
          ...(typographyStyles["body-md"] as any),
        }}
      />
    </>
  );
};

export function NaturalLanguageFeature() {
  return {
    left: {
      title: "Natural Language",
      description:
        '"Can you reconcile my shopify transactions and tell me my cashflow?"',
      button: {
        text: "Learn more",
        onClick: () => {},
      },
    },
    center: {
      backgroundPattern: "dots",
      renderChildren: () => {
        return (
          <>
            <div className="shadow-sm rounded-md overflow-hidden">
              <ThreadMessageList
                stickyBackdropColor={"var(--background)"}
                isWorkflowExecutionThread={false}
                isStreaming={false}
                awaitingAgentReply={false}
                messages={{
                  __typename: "MessageObjectORMConnection",
                  edges: [
                    {
                      __typename: "MessageObjectEdge",
                      node: {
                        __typename: "MessageObject",
                        id: identifierAndTypenameToId(
                          "49b5f8db-fa3f-4504-8f79-611d78116471",
                          "MessageObject",
                        ),
                        identifier: "1",
                        createdAt: new Date(),
                        content: [
                          {
                            __typename: "MessageContentObject",
                            id: "demo-content-1",
                            identifier: "demo-content-1",
                            createdAt: new Date().toISOString(),
                            order: 0,
                            text: "What does my cashflow look like?",
                            context: null,
                            nodes: [],
                          },
                        ],
                        context: [],
                        references: [],
                        files: [],
                        account: {
                          __typename: "AccountObject",
                          id: identifierAndTypenameToId(
                            "49b5f8db-fa3f-4504-8f79-611d78116471",
                            "AccountObject",
                          ),
                          identifier: "49b5f8db-fa3f-4504-8f79-611d78116471",
                        },
                        timeSeriesData: null,
                      },
                    },
                    {
                      __typename: "MessageObjectEdge",
                      node: {
                        __typename: "MessageObject",
                        id: identifierAndTypenameToId(
                          "49b5f8db-fa3f-4504-8f79-611d78116471",
                          "MessageObject",
                        ),
                        identifier: "2",
                        createdAt: new Date(),
                        content: [
                          {
                            __typename: "MessageContentObject",
                            id: "demo-content-2",
                            identifier: "demo-content-2",
                            // Shown a couple of seconds into the reply, so the
                            // demo reads "Thought · 2 seconds" like a real one.
                            createdAt: new Date(
                              Date.now() + 2_000,
                            ).toISOString(),
                            order: 0,
                            text: "Here's your cashflow for the next 3 months.",
                            context: null,
                            nodes: [],
                          },
                        ],
                        context: [],
                        references: [],
                        files: [],
                        account: null,
                        timeSeriesData: {
                          __typename: "ChartData",
                          title: "Cashflow",
                          series: ["Incoming", "Outgoing", "Net"],
                          labelFormat: ChartFormatEnum.Date,
                          labelAxis: "",
                          valueAxis: "",
                          valueFormat: ChartFormatEnum.Currency,
                          points: [
                            {
                              __typename: "ChartPoint",
                              label: "2025-01-01",
                              values: [
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Incoming",
                                  value: "2450",
                                },
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Outgoing",
                                  value: "-540",
                                },
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Net",
                                  value: "1910",
                                },
                              ],
                            },
                            {
                              __typename: "ChartPoint",
                              label: "2025-02-01",
                              values: [
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Incoming",
                                  value: "1920",
                                },
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Outgoing",
                                  value: "-420",
                                },
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Net",
                                  value: "1500",
                                },
                              ],
                            },
                            {
                              __typename: "ChartPoint",
                              label: "2025-03-01",
                              values: [
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Incoming",
                                  value: "2030",
                                },
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Outgoing",
                                  value: "-450",
                                },
                                {
                                  __typename: "ChartSeriesPoint",
                                  key: "Net",
                                  value: "1580",
                                },
                              ],
                            },
                          ],
                        },
                      },
                    },
                  ],
                }}
              />
            </div>
            {/* Top thread bot */}
            <ThreadBox
              mode="edit"
              isMainThread={true}
              activeMessageContext={[
                {
                  id: identifierAndTypenameToId(
                    "49b5f8db-fa3f-4504-8f79-611d78116471",
                    "Transaction",
                  ),
                  identifier: "49b5f8db-fa3f-4504-8f79-611d78116471",
                  name: "Shopify Transaction",
                  typename: "Transaction",
                },
              ]}
              ThreadComposerComponent={MockInputComponent as any}
              ThreadReferencePopperComponent={MockComponent as any}
              ThreadTogglePopperComponent={MockComponent as any}
              onSubmit={() => {}}
              onRemoveReference={() => {}}
              onModeChange={() => {}}
              onAddReference={() => {}}
              onSelectThread={() => {}}
              onNewThread={() => {}}
            />
          </>
        );
      },
    },
    right: {
      renderChildren: () => null,
      renderHoverAnimation: (isHovering) => {
        return (
          <>
            {/* Top thread bot */}
            <div
              className={cn(
                "[transition:0.3s_all]",
                !isHovering ? "w-36" : "w-42.5",
                "h-14 bg-background [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-sm absolute left-8 -top-4 shadow-sm",
              )}
            >
              <div className="absolute bottom-0 left-4 h-4 w-4 rounded-[2px] transform-[rotate(45deg)_translate(20%,30%)] [transition:0.3s_all] [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] bg-background z-100" />
              <div className="relative flex pt-2 pl-2 pr-2 h-full w-full flex-col bg-background rounded-sm z-100 gap-1">
                <div
                  className={cn(
                    "h-2",
                    !isHovering ? "w-16" : "w-20",
                    "rounded-lg [transition:0.3s_all]",
                    isHovering
                      ? "bg-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]"
                      : "bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]",
                    "z-100",
                  )}
                />
                <div
                  className={cn(
                    "h-2",
                    !isHovering ? "w-24" : "w-27",
                    "rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] z-100",
                  )}
                />
                <div
                  className={cn(
                    "h-2",
                    !isHovering ? "w-18" : "w-14",
                    "rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] z-100",
                  )}
                />
                <div className="h-2 w-8 rounded-lg [transition:0.3s_all] z-100" />
              </div>
            </div>

            {/* Bottom thread bot */}
            <div
              className={cn(
                "[transition:0.3s_all]",
                !isHovering ? "w-36" : "w-42.5",
                "h-14 bg-background [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-sm absolute right-8 -bottom-4 shadow-sm",
              )}
            >
              <div className="absolute bottom-0 right-4 h-4 w-4 rounded-[2px] transform-[rotate(45deg)_translate(20%,30%)] [transition:0.3s_all] [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] bg-background z-100" />
              <div className="relative flex p-2 h-full w-full bg-background rounded-sm z-100 pl-2 pr-2 pt-2 gap-1 flex-col">
                <div
                  className={cn(
                    isHovering ? "w-16" : "w-20",
                    "h-2 rounded-lg [transition:0.3s_all]",
                    isHovering
                      ? "bg-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]"
                      : "bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]",
                    "z-100",
                  )}
                />
                <div
                  className={cn(
                    "h-2",
                    !isHovering ? "w-24" : "w-28",
                    "rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] z-100",
                  )}
                />
                <div
                  className={cn(
                    "h-2",
                    !isHovering ? "w-18" : "w-20",
                    "rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] z-100",
                  )}
                />
              </div>
            </div>
          </>
        );
      },
      backgroundPattern: "dots",
    },
  };
}
